import { map } from 'lodash';
import React from 'react';
import styled from 'styled-components';

import { BaseDebugContainer } from 'src/presentation/components/pages/integrations/lookupAdapterDebugging/components/LookupDebuggingStyles';
import lookupDebuggerDetailedResource from 'src/actions/integrations/lookupAdapterDebugging/lookupDebuggerDetailedResource';
import RequestContainer from 'src/presentation/components/pages/integrations/lookupAdapterDebugging/components/RequestContainer';
import ResponseContainer, {
  StyledErrorIcon,
  RowText,
} from 'src/presentation/components/pages/integrations/lookupAdapterDebugging/components/ResponseContainer';
import { Row } from 'src/presentation/components/forms/Layout';
import { useResourceValue } from 'src/presentation/hooks/useDocumentResource';

const DetailedDebuggingResults = (): JSX.Element => {
  const { value: debugResults, loadingState, errors } = useResourceValue(lookupDebuggerDetailedResource);
  const rawResponse = debugResults?.response?.rawResponse && atob(debugResults.response.rawResponse);

  const errorComponents = map(errors, (error, idx) => {
    let errorText;
    if (error.code === 'timeout') {
      errorText = 'The request to the lookup adapter timed out.';
    } else {
      errorText = 'Something went wrong. Please try again.';
    }

    return (
      <Row key={`debug-error-${idx}`}>
        <StyledErrorIcon />
        <RowText>{errorText}</RowText>;
      </Row>
    );
  });

  if (loadingState === 'unstarted') {
    return <></>;
  }

  return (
    <>
      <StepContainer>Gladly is now testing the Detailed workflow</StepContainer>
      <StepDivider />
      {loadingState === 'succeeded' ? (
        <>
          <RequestContainer request={debugResults?.request} requestType="Detailed" />
          <ResponseContainer
            requestType="Detailed"
            response={debugResults.response}
            rawResponse={rawResponse}
            validationErrors={debugResults?.validationErrors}
          />
        </>
      ) : null}
      {loadingState === 'failed' ? <DebugStepContainer>{errorComponents}</DebugStepContainer> : null}
    </>
  );
};

export default DetailedDebuggingResults;

const StepDivider = styled.div`
  height: 16px;
  border-left: 4px dotted ${p => p.theme.colors.gray700};
  margin: 8px 24px;
`;

const DebugStepContainer = styled.div`
  ${BaseDebugContainer}
  margin: 12px 0 12px 24px;
`;

const StepContainer = styled.div`
  padding 0 24px;
`;
